import React, { useState, useEffect, useMemo, useCallback } from "react"
import * as JobsStyles from "./Jobs.module.scss"
import { useStaticQuery, graphql } from "gatsby"
import RichTextRenderer from "../RichTextRenderer/RichTextRenderer"
import { LocationMarkerIcon, FilterIcon } from "@heroicons/react/solid"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import JobsSearch from "../JobsSearch/JobsSearch"
import { ComeetToJson } from "./ComeetToJson"
import parse from "html-react-parser"

const Jobs = () => {
  // const data = useStaticQuery(graphql`
  //   query JobsQuery {
  //     allContentfulJob(
  //       sort: { fields: country___flagIcon___title, order: DESC }
  //     ) {
  //       nodes {
  //         department
  //         description {
  //           raw
  //         }
  //         country {
  //           country
  //           flagIcon {
  //             title
  //             gatsbyImageData(width: 50, height: 50, placeholder: NONE)
  //           }
  //         }
  //         location
  //         title
  //         link
  //       }
  //     }
  //     allContentfulFlagIcon(
  //       filter: { country: { in: ["Israel", "United States", "Ukraine"] } }
  //     ) {
  //       edges {
  //         node {
  //           country
  //           flagIcon {
  //             gatsbyImageData(width: 50, height: 50, placeholder: NONE)
  //           }
  //         }
  //       }
  //     }
  //   }
  // `)

  const data = useStaticQuery(graphql`
    query JobsQuery {
      allContentfulFlagIcon(
        filter: { country: { in: ["Israel", "United States", "Ukraine", "India"] } }
      ) {
        edges {
          node {
            country
            flagIcon {
              gatsbyImageData(width: 50, height: 50, placeholder: NONE)
            }
          }
        }
      }
    }
  `)

  // Jobs are coming from Contentful and from Comeet !!

  const [filter, setFilter] = useState(null)
  const [comeetJobs, setComeetJobs] = useState([])
  const [contentfulJobs, setContentfulJobs] = useState([])
  const [jobs, setJobs] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  const {
    allContentfulFlagIcon,
    // allContentfulJob: { nodes: contentfulJobs },
  } = data

  let jobsData = useMemo(() => [], [])
  let flags = useMemo(() => [], [])

  const getComeetJobs = useCallback(() => {
    ComeetToJson()
      .then(response => {
        setComeetJobs(
          response.sort((a, b) => {
            if (a.country.country == "United States") return -1
          })
        )
        setIsLoading(false)
      })
      .catch(e => {
        console.log("failed to load comeet careers")
      })
  }, [])

  useEffect(() => {
    getComeetJobs()
  }, [getComeetJobs])

  useEffect(() => {
    if (comeetJobs.length) {
      jobsData["Israel"] = []
      flags["Israel"] = (
        <GatsbyImage
          layout="fullWidth"
          image={getImage(
            allContentfulFlagIcon.edges.find(
              flag => flag.node.country == "Israel"
            ).node.flagIcon.gatsbyImageData
          )}
          alt="Israel"
        />
      )
      flags["United States"] = (
        <GatsbyImage
          layout="fullWidth"
          image={getImage(
            allContentfulFlagIcon.edges.find(
              flag => flag.node.country == "United States"
            ).node.flagIcon.gatsbyImageData
          )}
          alt="US"
        />
      )
      flags["Ukraine"] = (
        <GatsbyImage
          layout="fullWidth"
          image={getImage(
            allContentfulFlagIcon.edges.find(
              flag => flag.node.country == "Ukraine"
            ).node.flagIcon.gatsbyImageData
          )}
          alt="US"
        />
      )
      flags["India"] = (
        <GatsbyImage
          layout="fullWidth"
          image={getImage(
            allContentfulFlagIcon.edges.find(
              flag => flag.node.country == "India"
            ).node.flagIcon.gatsbyImageData
          )}
          alt="US"
        />
      )
      comeetJobs.forEach(job => {
        if (job.country.country in jobsData) {
          jobsData[job.country.country].push(job)
        } else {
          jobsData[job.country.country] = [job]
        }
      })
      setJobs(comeetJobs.concat(contentfulJobs))
    } else {
      setJobs(contentfulJobs)
    }
  }, [comeetJobs, contentfulJobs])

  const filterJobsCountry = useCallback(() => {
    contentfulJobs.forEach(job => {
      if (jobsData[job.country.country] instanceof Array === false) {
        jobsData[job.country.country] = []
        flags[job.country.country] = (
          <GatsbyImage
            layout="fullWidth"
            image={getImage(job.country.flagIcon.gatsbyImageData)}
            alt={job.country.country}
          />
        )
      }
      jobsData[job.country.country].push(job)
    })
  }, [])

  useEffect(() => {
    filterJobsCountry()
  }, [filterJobsCountry])

  const [jobsFiltered, setJobsFiltered] = useState([])
  const [searchInputValue, setSearchInputValue] = useState("")

  useEffect(() => {
    if (filter) {
      setJobsFiltered(jobsData[filter])
    } else {
      setJobsFiltered(jobs)
    }

    if (searchInputValue) {
      handleSearchInputChanged(searchInputValue)
    }
  }, [filter, jobs, jobsData, comeetJobs])

  const handleSearchInputChanged = value => {
    setSearchInputValue(value)
    if (value === "") {
      setJobsFiltered(filter ? jobsData[filter] : jobs)
    } else {
      let jobsToSearch
      if (filter) {
        jobsToSearch = jobsData[filter]
      } else {
        jobsToSearch = jobs
      }

      setJobsFiltered(
        jobsToSearch.filter(job =>
          job.title.toLowerCase().includes(value.toLowerCase())
        )
      )
    }
  }

  if (isLoading) {
    return <div>Loading Careers...</div>
  }

  return (
    <div className={JobsStyles.jobs}>
      <div className={JobsStyles.filters}>
        <button
          className={`${JobsStyles.filter} ${
            filter === null ? JobsStyles.active : null
          }`}
          onClick={() => setFilter(null)}
        >
          All ({jobs.length})
        </button>
        {Object.keys(jobsData)
          .sort(a => {
            if (a == "United States") return -1
          })
          .map(country => (
            <button
              className={`${JobsStyles.filter} ${
                filter === country ? JobsStyles.active : null
              }`}
              onClick={() => setFilter(country)}
            >
              {country} ({jobsData[country].length})
            </button>
          ))}
      </div>
      <div>
        <div className={JobsStyles.searchAndResults}>
          <JobsSearch valueChanged={handleSearchInputChanged} />
          <div className={JobsStyles.totalResults}>
            {jobsFiltered.length} Jobs Found{" "}
            {searchInputValue && `(showing results for "${searchInputValue}")`}
          </div>
        </div>
        {jobsFiltered.map(job => {
          return (
            <div className={JobsStyles.job}>
              <div className={JobsStyles.flag}>
                <a href={job.link} target="_blank" rel="noreferrer">
                  {flags[job.country.country]}
                </a>
              </div>
              <div className={JobsStyles.text}>
                <div className={JobsStyles.title}>{job.title}</div>
                <div className={JobsStyles.details}>
                  <div className={JobsStyles.detailsLeft}>
                    <a href={job.link} className={JobsStyles.companyLink}>
                      @SciPlay{" "}
                      {job.country.country === "United States"
                        ? "USA"
                        : job.country.country}
                    </a>{" "}
                    |{" "}
                    <LocationMarkerIcon
                      width={16}
                      height={16}
                      style={{ display: "inline-block" }}
                    />{" "}
                    {job.location}, {job.country.country}
                  </div>
                  <div className={JobsStyles.button}>
                    <a href={job.link} target="_blank" rel="noreferrer">
                      READ MORE
                    </a>
                  </div>
                </div>
                <div className={JobsStyles.careersDepartment}>
                  <FilterIcon
                    width={16}
                    height={16}
                    style={{ display: "inline-block" }}
                  />
                  {job.department}
                </div>
                {job.description && (
                  <div>
                    {job.isComeetJob ? (
                      <>{parse(job.description)}</>
                    ) : (
                      <RichTextRenderer content={job.description} />
                    )}
                  </div>
                )}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
export default Jobs
